import fiction from "./fiction/";
import general from "./general";
import historical from "./historical";
import legal from "./legal";
import pm from "./pm";

export default [
  {
    id: "general",
    label: "General",
    icon: "basic",
    templates: general
  },
  {
    id: "fiction",
    label: "Fiction",
    icon: "fiction",
    templates: fiction
  },
  {
    id: "pm",
    label: "Project Management",
    icon: "pm",
    templates: pm
  },
  {
    id: "legal",
    label: "Legal",
    icon: "legal",
    templates: legal
  },
  {
    id: "historical",
    label: "Historical",
    icon: "historical",
    templates: historical
  }
];
